
const handleResponse = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error(response.statusText);
};

const getUrlId = () => {
  const pathname = window.location.pathname;
  return pathname ? pathname.substring(pathname.lastIndexOf('/') + 1) : '';
};

const RedirectToUrlDirect = (url) => {
  if (url) window.location.replace(url);
};

export { handleResponse, getUrlId, RedirectToUrlDirect };
